import template from './index.pug'
import CallStatusMappingForm from '../components/_form.js'

export default Vue.extend({
  template: template(),
  components: {
    CallStatusMappingForm
  },
  methods: {
    t(key) {
      return this.$t(`callStatusMappings.new.${key}`);
    } 
  }
})